<template>
  <div>
    <div class="header">
      <div class="wd relative">
        <a href="/"><img src="../assets/images/logo.png" height="50" width="300"></a>
        <ul class="hd-menu clearfix">
          <li><a href="/" :class="{'a-active': homeActive == true}">首页</a></li>
          <li><a href="javascript:void (0);" @click="toProductInfo" :class="{'a-active': productInfoActive == true}">产品服务</a></li>
          <li><a href="javascript:void (0);" @click="toServiceProduct" :class="{'a-active': productActive == true}">服务特色</a></li>
          <li><a href="javascript:void (0);" @click="toServicePartner" :class="{'a-active': partnerActive == true}">服务行业</a></li>
          <li><a href="javascript:void (0);" @click="toAboutUs" :class="{'a-active': aboutUsActive == true}">关于我们</a></li>
          <li><a href="javascript:void (0);" @click="toContact" :class="{'a-active': contactActive == true}">联系我们</a></li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Header',
    data () {
      return {
        homeActive: true,
        productInfoActive: false,
        productActive: false,
        partnerActive: false,
        aboutUsActive: false,
        contactActive: false
      }
    },
    /*mounted: function () {
      let that = this;

      that.productInfoActive = false;
      that.productActive = false;
      that.partnerActive = false;
      that.aboutUsActive = false;
      that.contactActive = false;
    },*/
    methods: {
      toProductInfo(){
        let that = this;

        that.homeActive = false;
        that.productInfoActive = true;
        that.productActive = false;
        that.partnerActive = false;
        that.aboutUsActive = false;
        that.contactActive = false;
        that.$router.replace('/productInfo');
      },
      toServiceProduct(){
        let that = this;

        that.homeActive = false;
        that.productInfoActive = false;
        that.productActive = true;
        that.partnerActive = false;
        that.aboutUsActive = false;
        that.contactActive = false;
        that.$router.replace('/product');
      },
      toServicePartner(){
        let that = this;

        that.homeActive = false;
        that.productInfoActive = false;
        that.productActive = false;
        that.partnerActive = true;
        that.aboutUsActive = false;
        that.contactActive = false;
        that.$router.replace('/partner');
      },
      toAboutUs(){
        let that = this;

        that.homeActive = false;
        that.productInfoActive = false;
        that.productActive = false;
        that.partnerActive = false;
        that.aboutUsActive = true;
        that.contactActive = false;
        that.$router.replace('/about');
      },
      toContact(){
        let that = this;

        that.homeActive = false;
        that.productInfoActive = false;
        that.productActive = false;
        that.partnerActive = false;
        that.aboutUsActive = false;
        that.contactActive = true;
        that.$router.replace('/contact');
      }
    }
  }
</script>

<style scoped>

  .a-active {
    color: #349eb8 !important;
  }

  .a-active:before {
    color: #349eb8 !important;
    content: '[';
    -webkit-transform: translateX(20px);
    -moz-transform: translateX(20px);
    transform: translateX(20px);
  }

  .a-active:after {
    color: #349eb8 !important;
    content: ']';
    -webkit-transform: translateX(20px);
    -moz-transform: translateX(20px);
    transform: translateX(20px);
  }

  .a-active:before, .a-active:after{
    opacity: 1;
    -webkit-transform: translateX(0px);
    -moz-transform: translateX(0px);
    transform: translateX(0px);
  }

</style>


// WEBPACK FOOTER //
// src/components/Header.vue